<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card shadow-sm mb-4">
                <div class="card-header">
                    <h3 class="card-title">{{ projectId ? 'Edit Project' : 'Create Project' }}</h3>
                    <button type="button" class="btn btn-success ms-auto" (click)="goToViewProject()"
                        [disabled]="!project">
                        View Project
                    </button>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <projects-accordion [projectId]="projectId" [project]="project"
                                (onFormDataUpdated)="onFormDataUpdated($event)">
                            </projects-accordion>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-4 mb-4">
        <div class="col-12 text-end">

        </div>
    </div>
</div>